import colors from '@/styles/colors';
import fonts from '@/styles/fonts';
import styled from 'styled-components';

export const TableContainer = styled.table`
      border-collapse: collapse;
      margin: 0;
      padding: 0;
      width: 100%;
      table-layout: fixed;
      margin-bottom: 19em;
      /* position: relative; */

      tr th{
         cursor: pointer;
      }
      th, td {
         text-align: center;
         padding: 1.5em  0em;
      }

      th:first-child, td:first-child{
         text-align: left;
      }
      td:last-child{
         display: flex;
         align-items: center;
         justify-content: center;
      }

      th {

         font-size: .875em;
         line-height: 17.09px;
         letter-spacing: 1%;
         padding: 1.5em  .5em;
         color: ${colors.grayDarker};
         font-family: ${fonts.Inter.Medium};
 
         span{
            margin-right: 0.5em;
         }
      }
      td:nth-child(2) div{
         display: flex;
         align-items: center;
         justify-content: center;
         cursor: pointer;
      }
      th:last-child,tr td:nth-child(2){
         display: flex;
         align-items: center;
         justify-content: center;
      }

      td{
         font-size: .875em;
         line-height: 16.94px;
         letter-spacing: 1%;
         color: ${colors.blackLight};
      }
      tbody{
         position: relative;
      }
   
      tfoot{
         tr {
            background-color: ${colors.gray100};
            th span{
               display: none;
            }
         }
      }

      @media screen and (max-width: 1200px) {
         display: block;
         max-width: -moz-fit-content;
         max-width: fit-content;
         margin: 0 auto;
         overflow-x: auto;
         white-space: nowrap;
         margin-bottom: 19em;

      }
`;

export const TableTr = styled.tr<{tagColor?:string}>`
   border: 1px solid ${colors.grayExtraLight};
   padding: .35em;
   border-left-color: ${colors.transparent};
   border-right-color: ${colors.transparent};
   :hover{
      background-color: ${colors.gray100};
   }
   background-color: ${props => props.tagColor|| colors.white};
`;

export const FormContainer = styled.div`
  position: absolute;
`